module.exports = __webpack_public_path__ + "img/madeInGermany.4faff19.jpg";